import { FC, useEffect, useState } from 'react';
import { Container, NavPanel, ScreenWrapper, LaunchScreenWrapper } from './SignUpFlowPage.styles';
import { NavigationPanel } from '../../common/components/NavigationPanel/NavigationPanel';
import { useAppDispatch, useTypedSelector } from '../../store/store';
import { SignUpScreen } from './SignUpScreen/SignUpScreen';
import { setSignUpFlowActiveTabIndex } from '../../store/slices/ui';
import { authWithPartnerToken } from '../../store/slices/me';
import { useQuery } from '../../services/hooks/useQuery';
import WelcomeVideoPage from '../WelcomeVideoPage/WelcomeVideoPage';
import LaunchScreen from '../LaunchScreen/LaunchScreen';
import { useClientType } from '../../services/hooks/useClientType';
import { useTrackEvent } from '../../common/hooks/useTrackEvent';
import { EventNames } from '../../common/constants/constants';

interface Props {
  isDataLoading: boolean;
}

export const SignUpFlowPage: FC<Props> = ({ isDataLoading }) => {
  const dispatch = useAppDispatch();
  const { currentCampaign } = useTypedSelector((state) => state.rewards);
  const { signUpFlowActiveTabIndex } = useTypedSelector((state) => state.ui);
  const [isRecordVideoScreen, setIsRecordVideoScreen] = useState(false);
  const [isLaunchScreen, setIsLaunchScreen] = useState(false);
  const { isUploadInprogress, uploadingProgress } = useTypedSelector((state) => state.upload);
  const { items: questions } = useTypedSelector((state) => state.ui.questions);
  const [showBlur, setShowBlur] = useState(false);
  const [delayed, setDelayed] = useState(false);

  const { isUVMClient } = useClientType();

  const query = useQuery();
  const partnerToken = query.get('partner-token');

  const {
    account: { id: accountId },
    accountAttributes: { properties },
  } = useTypedSelector((state) => state.account);
  const hideBackgroundImages = properties?.['webapp.config']?.hideBackgroundImages;
  const { trackEvent } = useTrackEvent();
  const hasAnsweredQuestions = questions.length > 1;
  const useCustomBranding = properties?.['webapp.branding']?.useCustomBranding;
  const backgroundColorPrimary = properties?.['webapp.branding']?.backgroundColorPrimary;
  const backgroundImage = properties?.['webapp.branding']?.backgroundImagePrimary;
  const backgroundImageSecondary = properties?.['webapp.branding']?.backgroundImageSecondary;
  const backgroundColorSecondary = properties?.['webapp.branding']?.backgroundColorSecondary;

  const completeScreenCustomBackground = useCustomBranding ? backgroundImage ? `url(${backgroundImage})` : backgroundColorPrimary ? backgroundColorPrimary : null : null;
  const uploadScreenCustomBackground = useCustomBranding ? backgroundImageSecondary ? `url(${backgroundImageSecondary})` : backgroundColorSecondary ? backgroundColorSecondary : null : null;
 
  const isCompleteScreen = (isUploadInprogress || uploadingProgress === 100) && hasAnsweredQuestions;

  const background = uploadScreenCustomBackground ? uploadScreenCustomBackground : isUVMClient ? '#C3D8E5' : hideBackgroundImages ? 'white' : `url(/mattrogers05.png)`;

  const completeScreenBackground = completeScreenCustomBackground ? completeScreenCustomBackground : `url(/mattrogers01.jpg)`;

  const isBackgroundChanging = !isUVMClient && delayed;

  useEffect(() => {
    if (partnerToken) {
      dispatch(authWithPartnerToken({ accountId, token: partnerToken }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);
  useEffect(() => {
    let timer: number;
    if (isCompleteScreen && !isUVMClient) {
      setShowBlur(true);
      setTimeout(() => {
        setDelayed(true);
      }, 700);
      trackEvent({ action: EventNames.complete_screen_page_view });
      timer = setTimeout(() => {
        setShowBlur(false);
      }, 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [isCompleteScreen, isUVMClient]);

  useEffect(() => {
    if (currentCampaign?.welcomeVideoUrl) {
      fetch(currentCampaign?.welcomeVideoUrl);
      fetch(currentCampaign?.welcomeVideoUrl?.replace(/\....$/, '.jpg').replace('/upload/', '/upload/so_0,'));
    }
  }, [currentCampaign?.welcomeVideoUrl]);

  if (isDataLoading || isLaunchScreen) {
    return (
      <LaunchScreenWrapper>
        <LaunchScreen isLoading={isDataLoading} setIsLaunchScreen={setIsLaunchScreen} />
      </LaunchScreenWrapper>
    );
  }
  const handleWelcomeVideoNext = () => {
    dispatch(setSignUpFlowActiveTabIndex(1));
  };

  return (
    <Container
      $fadeOut={showBlur}
      $fadeIn={isBackgroundChanging}
    >
      <ScreenWrapper
        $background={background}
        style={
          isCompleteScreen && isBackgroundChanging
            ? { background: completeScreenBackground, backgroundSize: '100% 100%' }
            : {}
        }
      >
        {currentCampaign?.welcomeVideoUrl && currentCampaign.showWelcomeVideo && signUpFlowActiveTabIndex === 0 ? (
          <WelcomeVideoPage handleNextStep={handleWelcomeVideoNext} />
        ) : (
          <SignUpScreen isRecordVideoScreen={isRecordVideoScreen} setIsRecordVideoScreen={setIsRecordVideoScreen} />
        )}
      </ScreenWrapper>
      {!isRecordVideoScreen && !isLaunchScreen && (
        <NavPanel>
          <NavigationPanel activeIndex={signUpFlowActiveTabIndex} />
        </NavPanel>
      )}
    </Container>
  );
};
